import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { createCustomReport } from '../../service/customReportService'
import { CustomReport } from '../../../../redux/context/customReports/types'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import customReportQueryKeys from '../customReportQueryKeys'
import { showCreateSuccessMessage, showErrorMessage } from '../../../../utils/message'

export const useCtxCreateCustomReport = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: Partial<CustomReport>) => createCustomReport(data, companyId),
    onSuccess: () => {
      showCreateSuccessMessage()
      return queryClient.invalidateQueries({
        queryKey: customReportQueryKeys.list(companyId)
      })
    },
    onError: () => {
      showErrorMessage()
    }
  })
}
